import { apiBaseUrl } from '../config/env';

export function getBaseUrl() {
  return apiBaseUrl;
}

/** Smash API base → Booga auth API base. */
export function getAuthBaseUrl() {
  const smash = getBaseUrl();
  if (smash && smash.includes('/api/smash/v1')) {
    return smash.replace(/\/api\/smash\/v1\/?$/, '/api/auth');
  }
  if (smash && smash.startsWith('http')) {
    const origin = new URL(smash).origin;
    return `${origin}/api/auth`;
  }
  return `${window.location.origin}/api/auth`;
}
